<section class="flex gap-12">
  @if (vm.loading) {
    <section class="flex-col gap-12">
      <app-skeleton-loader class="h-48 min-w-280" />
      <app-skeleton-loader class="h-48 min-w-280" />
      <app-skeleton-loader class="h-48 min-w-280" />
    </section>
  } @else {
    @for (option of vm.serviceOptions; track option.title; let index = $index) {
      <app-radio-button
        variant="blue"
        [ngModel]="vm.formValue?.['service_option']"
        [includeResetOption]="false"
        name="service_option"
        [index]="index"
        [optionValue]="option.value"
      >
        {{ option.title }}
      </app-radio-button>
    }
  }
</section>
